import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import iconClose from '../../assets/icons/icons_multimedia_24_close_pip.svg';
import { IAppState } from '../../store';
import { FlashMessageStyle, IFlashMessageState } from '../../actions/flashMessageAction';

interface ReduxStateProps {
    messageState: IFlashMessageState;
    messageStyle: FlashMessageStyle;
}

const FlashMessage:React.FC = ({ children }) => {
  const [showMessage, setShowMessage] = useState(false);
  const {
    messageState: newMessageState,
    messageStyle,
  } = useSelector<IAppState, ReduxStateProps>((state) => ({
    messageState: state.flashMessageState,
    messageStyle: state.flashMessageState.style,
  }));
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>();

  useEffect(() => {
    if (newMessageState.message.length > 0) {
      setShowMessage(true);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      setTimeoutId(setTimeout(() => closeMessage(), 5000));
    } else setShowMessage(false);
  }, [newMessageState]);

  const closeMessage = () => setShowMessage(false);

  return (
    <div className="relative">
      <div>
        {children}
      </div>
      {showMessage
        && (
        <div className={`fixed top-0 right-0 w-full shadow ${messageStyle === 'error' ? 'bg-red-200/[0.95]' : 'bg-green-200/[0.95]'}`}>
          <div className={`flex flex-row ${messageStyle === 'error' ? 'text-red-700' : 'text-black'} px-4 py-3 items-center`} role="alert">
            <span className="grow flex justify-center">{newMessageState.message}</span>
            <div className="flex-none">
              <button
                className="mt-1"
                type="button"
                onClick={() => closeMessage()}
              >
                <img src={iconClose} alt={iconClose} />
              </button>
            </div>
          </div>
        </div>
        )}
    </div>
  );
};

export default FlashMessage;
